export const CreateOrganizationNamespace = "createOrganization";
